import React from "react";
import { Card, Form, Radio, Space } from "antd";

export default function QuestionCard(props) {
    // props: id = 1/2/... question=q options=[]

    return (
        <Form.Item name={props.question} rules={[{ required: true, message: "Please select an option" }]}   
            style={{ display: props.curr === props.id ? "block" : "none" }}>
            <Card title={`${props.id}. ${props.question}`}
                headStyle={{ backgroundColor: "#4e756c", color: "white", fontWeight: "bold", fontSize: "20px" }}
                className="border-0" >
                <Radio.Group>
                    <Space direction="vertical">
                        {props.options.map((a, i) => (
                            <Radio key={i} value={a} style={{ fontSize: "20px" }}>{a}</Radio>
                        ))}
                    </Space>
                </Radio.Group>
            </Card>
        </Form.Item>
    )
}